import Component from '../../../shared/component';

export default class ConversationImageAttachment extends Component {
  constructor(containerElement) {
    super(...arguments);

    this.$containerElement = $(containerElement);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$containerElement.on(
      'click',
      '.message-body-imageAttachment-trigger',
      this.handleClick
    );
  }

  unbindEvents() {
    this.$containerElement.off(
      'click',
      '.message-body-imageAttachment-trigger',
      this.handleClick
    );
  }

  handleClick(event) {
    event.preventDefault();

    const originalURL = $(event.target).data('original-url');

    this.openModalForImage(originalURL);
  }

  openModalForImage(url) {
    const modalTemplate = `
      <div class="modal fade imageModal">
        <div class="imageAttachmentModal">
          <img src="${url}" class="imageAttachmentModal-image" />
        </div>
      </div>
    `;

    $(modalTemplate).modal();
  }
}
